<template>
  <v-autocomplete
    :value="value"
    :items="regionsList"
    :label="$t('REGIONS.ITEMS')"
    :search-input.sync="search"
    :counter="counter"
    :menu-props="menuProps"
    item-value="id"
    item-text="name"
    multiple
    chips
    small-chips
    deletable-chips
    append-outer-icon="mdi-close"
    v-bind="$attrs"
    v-on="listeners"
  ></v-autocomplete>
</template>

<script>
import { mapCacheActions } from 'vuex-cache';
import clearableSelectFilter from '../filters/mixins/clearableSelectFilter';

export default {
  name: 'RegionsFilter',

  mixins: [clearableSelectFilter],

  data() {
    return {
      regionsList: []
    };
  },

  mounted() {
    this.retrieveRegions().then(({ data }) => {
      this.regionsList = data.data;
    });
  },

  methods: {
    ...mapCacheActions('region', ['retrieveRegions'])
  }
};
</script>

<style scoped></style>
